import React, {FC} from 'react';
import styled from 'styled-components';

import {DropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemCheckbox} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemCheckbox';
import {DropdownItemContent} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemNestedIcon} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemNestedIcon';
import {TagModel} from '../../../../../models/api/tagModel';
import {renderTagIcon} from '../../../../common/dropdowns/dropdownItemTagIcon';

/*
 * Props.
 */

interface SearchSelectedTagDropdownItemProps {
  selectedTag: TagModel;
  onSelect: () => void;
  isChecked: boolean;
}

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
`;

export const SearchSelectedTagDropdownItem: FC<SearchSelectedTagDropdownItemProps> = (props) => {
  const {selectedTag, onSelect, isChecked} = props;

  return (
    <DropdownItem
      onSelect={onSelect}
      renderRightContent={() => <DropdownItemCheckbox isChecked={isChecked} />}
      isChecked={isChecked}
    >
      <DropdownItemNestedIcon nestingLevel={0}>{renderTagIcon(selectedTag)}</DropdownItemNestedIcon>
      <DropdownItemContent isChecked={isChecked}>
        <StyledContentDiv>{selectedTag.name}</StyledContentDiv>
      </DropdownItemContent>
    </DropdownItem>
  );
};
